import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
// components
import AppButton from "../ui/AppButton";
import HeadingBox from "../ui/HeadingBox";
// icons
import { errorIcon } from "../../common/vector";

interface AppBookingErrorProps {
  onButtonClick: () => void;
  dataAttribute: string;
  title: string;
  subtitle: string;
}

export default function AppBookingError({ onButtonClick, dataAttribute, title, subtitle }: AppBookingErrorProps) {
  const { t } = useTranslation();

  // states
  const tenantInfo = useSelector((state: any) => state.tenant.tenantInfo);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeadingBox title={title} text={subtitle} icon={errorIcon.default} />
      <Box width={260} height={40} mt={5} ml="auto" mr="auto">
        <AppButton
          label={t("bookingForm.error.button")}
          onClick={onButtonClick}
          disableRipple={true}
          customBackgroundColor={tenantInfo?.style?.button?.color}
          customActiveColor={tenantInfo?.style?.button?.active}
          customHoverColor={tenantInfo?.style?.button?.hover}
          customClickColor={tenantInfo?.style?.button?.click}
          type="submit"
          fontSize="14px"
          dataAttribute={dataAttribute}
        />
      </Box>
    </>
  );
}
